import { DateTime } from 'luxon';

export const formatRelativeTime = (dateString: string): string => {
  const date = DateTime.fromISO(dateString);
  const now = DateTime.now();
  const diffInMillis = now.toMillis() - date.toMillis();

  const diff = now.diff(date, ['seconds', 'minutes', 'hours', 'days', 'months']);

  if (diffInMillis < 60 * 1000) {
    const seconds = Math.floor(diff.seconds);
    return `${seconds} seconds ago`;
  } else if (diffInMillis < 60 * 1000 * 60) {
    const minutes = Math.floor(diff.minutes);
    return `${minutes} ${minutes === 1 ? 'min' : 'mins'} ago`;
  } else if (diffInMillis < 60 * 1000 * 60 * 24) {
    const hours = Math.floor(diff.hours);
    return `${hours} ${hours === 1 ? 'hour' : 'hours'} ago`;
  } else if (diffInMillis < 60 * 1000 * 60 * 24 * 30) {
    const days = Math.floor(diff.days);
    return `${days} ${days === 1 ? 'day' : 'days'} ago`;
  } else {
    return date.toFormat('yyyy.MM.dd');
  }
};
